var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "sub-title pt-15" }, [
      _vm._v("\n    Escolha sua forma de pagamento\n  ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "btn-group mt-20 mb-10" }, [
      _c(
        "div",
        {
          staticClass: "btn bg-pink choose-payment",
          on: {
            click: function($event) {
              _vm.choosePayment("credit_card")
              _vm.scrollTo(".flags")
            }
          }
        },
        [_vm._v("\n      CARTÃO DE CRÉDITO\n    ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "btn choose-payment",
          class: {
            "btn-pink": _vm.acceptBoleto(),
            "btn-disabled": !_vm.acceptBoleto(),
            "btn--loading": _vm.preloader
          },
          on: {
            click: function($event) {
              _vm.choosePayment("boleto")
            }
          }
        },
        [_c("span", [_vm._v("GERAR BOLETO")])]
      )
    ]),
    _vm._v(" "),
    !_vm.acceptBoleto()
      ? _c("div", { staticClass: "warning" }, [
          _vm._v(
            "Opção de boleto indisponível pois você selecionou uma limpeza com menos de " +
              _vm._s(_vm.labelDaysToPay()) +
              " de antecedência."
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b9dd950", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b9dd950","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Checkout/Payment/ChoosePayment.vue
// module id = null
// module chunks = 